export default "__VITE_ASSET__7QEWcSYa__"